export enum SubscriptionQuery {
    PAYMENT="payment",
    SUBSCRIPTION="subscription",
    INVOICE="invoices",
    FIELD_LIST="field_list"
}
